import BaseRequest from '@/qingyu/request/base'
import { config } from '@/qingyu'

/**
 * 系统相关API请求类
 */
export default class SystemRequest extends BaseRequest {
  // 获取JSSDK配置
  getJssdkConfig(data) {
    return this.post(config.api.WECHAT.JSSDK_SIGN, data)
  }
} 